'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Auto-reload on deployment version mismatch (stale client bundle)
    if (error.message?.includes('Failed to find Server Action')) {
      window.location.reload();
    }
  }, [error]);

  // Don't render error UI while reloading for version mismatch
  if (error.message?.includes('Failed to find Server Action')) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'system-ui, sans-serif',
        backgroundColor: '#1a1a2e',
        color: '#eaeaea'
      }}
    >
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Something went wrong!</h1>
      <p style={{ color: '#888', marginBottom: '2rem' }}>
        {error.message || 'An unexpected error occurred'}
      </p>
      <button
        onClick={() => reset()}
        style={{
          padding: '12px 24px',
          fontSize: '1rem',
          backgroundColor: '#14828d',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        Try again
      </button>
    </div>
  );
}
